import React from 'react';

import {
  ISwitch,
} from './types';

import {
  StyledSwitch,
} from './styled';

export default ({
  defaultChecked,
  onChange,
}: ISwitch): JSX.Element => (
  <StyledSwitch
    defaultChecked={defaultChecked}
    onChange={onChange}
    checkedChildren="On"
    unCheckedChildren="Off"
  />
);
